import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const smartguide = () => import(/* webpackChunkName: "guide" */ "./src/pages/smartguide.vue")

export default new Router({
  base: `/qykj/${PROJECTNAME}`,
  mode: "history",
  fallback: false,
  routes: [
    {
      path: "/",
      redirect:'smartguide'
    },
    {
      path: "/smartguide",
      component: smartguide
    }
  ]
});



// WEBPACK FOOTER //
// ./js/router.js